import { render, staticRenderFns } from "./EmailMessageTemplateTextAreas.vue?vue&type=template&id=d4087f4c&scoped=true"
import script from "./EmailMessageTemplateTextAreas.vue?vue&type=script&lang=js"
export * from "./EmailMessageTemplateTextAreas.vue?vue&type=script&lang=js"
import style0 from "./EmailMessageTemplateTextAreas.vue?vue&type=style&index=0&id=d4087f4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4087f4c",
  null
  
)

export default component.exports